export default "__VITE_ASSET__DVIB7ykL__"